import {ProcessFlowchartEditorConfigurator} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorConfigurator';
import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';

import {FlowchartConfigWithMetadata} from '../redux/flowchartConfigAutosaveManagerCallbacks';
import {LoadedFlowchartData} from './executionFlowchartData';
import {ExecutionEditorMode} from './ExecutionFlowchartPaneTypes';

export function createInitialExecutionDraftState(
  data: LoadedFlowchartData,
  editorMode: ExecutionEditorMode,
  executionEditorConfigurator: ProcessFlowchartEditorConfigurator
): FlowchartConfigWithMetadata {
  return {
    staticFlowchart: data.initialStaticFlowchart,
    metadata: {
      transitions: data.initialTransitions,
      rootTaskSchema: data.rootTaskSchema,
      interactionState: {
        selectedNodeIds: new Set<string>(),
        selectedRowIds: new Set<string>(),
        selectedEdgeIds: new Set<string>(),
        edgeLabelsByEdgeId: {},
      },
      currentVersionId: null,
      didInitialFlowchartHaveChainedRouters: data.hasChainedRouters,
      flowchartTypeName: executionEditorConfigurator.flowchartTypeName,
      options: {
        isFlowchartModifiableOnCreation: editorMode === FlowchartEditorMode.ACM_EDITOR,
        isFlowchartModifiableAfterCreation: editorMode === FlowchartEditorMode.PCM_EDITOR,
      },
    },
  };
}
